module.exports = __webpack_public_path__ + "static/media/main1.a9b58b01.jpeg";